import { THEME } from 'src/styles/theme';
import { alpha, styled } from '@mui/material/styles';
import InputBase, { InputBaseProps } from '@mui/material/InputBase';
import InputLabel from '@mui/material/InputLabel';
import MuiFormControl from '@mui/material/FormControl';

const FormControl = styled(MuiFormControl)(({ theme }) => ({
  width: '100%',
  '& label': {
    fontSize: 14,
  },
}));

interface InputProps {
  fullWidth?: boolean;
}

const BootstrapInput = styled(InputBase, {
  shouldForwardProp: prop => prop !== 'fullWidth',
})<InputProps>(({ theme, fullWidth = false }) => ({
  'label + &': {
    marginTop: '6px',
    color: THEME.main.primary,
    '&:focus': {
      color: THEME.main.primary,
    },
    width: fullWidth ? '100%' : 'auto',
    ['@media (max-width:450px)']: {
      width: '80vw',
      marginTop: 0,
    },
  },
  '& .Mui-focused': {
    color: THEME.main.primary,
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: THEME.main.white,
    border: `1px solid #E4E7EC`,
    fontSize: 16,
    fontWeight: 500,
    width: fullWidth ? '100%' : 'auto',
    padding: '10px 12px',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    // Use the system font instead of the default Roboto font.
    fontFamily: ["'Inter', sans-serif", 'sans-serif'].join(','),
    '&:focus': {
      boxShadow: `${alpha(THEME.main.primary, 0.25)} 0 0 0 0.2rem`,
      borderColor: THEME.main.primary,
    },
    ['@media (max-width:450px)']: {
      padding: '8px 10px',
      border: '1px solid #D7D7D7',
      marginTop: '6px',
      '&:focus': {
        boxShadow: `${alpha(THEME.main.primary, 0.25)} 0 0 0 0.2rem`,
        border: '1px solid none',
        borderColor: 'transparent',
      },
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      '-moz-appearance': 'none',
      appearance: 'none',
      margin: 0,
    },
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      '-moz-appearance': 'none',
      appearance: 'none',
      margin: 0,
    },
    '-moz-appearance': 'textfield',
  },
}));

// const FormControl = styled(MuiFormControl)(({theme})=>({
//   width:
// }))

type Props = InputBaseProps & { label?: string; fullWidth?: boolean };

function TextField(props: Props) {
  return (
    <FormControl variant="standard">
      {props.label && <label htmlFor={props.id}>{props.label}</label>}
      <BootstrapInput fullWidth={props.fullWidth} {...props} />
    </FormControl>
  );
}

export default TextField;
